(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kaiko-mobile-product-layout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kaiko-product-layout')) {
    customElements.define('kaiko-product-layout', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('product-info');
        if (!this.root) return;
        this.desktop = window.matchMedia('(min-width: 768px)');
        this.onViewportChange = () => this.update();
        this.desktop.addEventListener('change', this.onViewportChange);
        this.update();
        this.observer = new MutationObserver(() => {
          if (this.queued) return;
          this.queued = true;
          requestAnimationFrame(() => { this.queued = false; if (this.isConnected) this.update(); });
        });
        this.observer.observe(this.root, { childList: true, subtree: true });
      }
      disconnectedCallback() { this.observer?.disconnect(); this.desktop?.removeEventListener('change', this.onViewportChange); }
      update() {
        const info = this.root.querySelector('.product__info-container');
        const buy = info?.querySelector('.product__block--buy_buttons');
        if (buy) {
          let slot = this.root.querySelector('.kaiko-bundle-slot');
          if (!slot) {
            slot = document.createElement('div');
            slot.className = 'kaiko-bundle-slot';
            const wishlist = info.querySelector('#swym-atw-button-container')?.closest('.product__block');
            (wishlist || buy).after(slot);
          }
          const media = this.root.querySelector('.product__media-container');
          const useDesktop = this.desktop.matches && media;
          let desktopExtras = this.root.querySelector('.kaiko-desktop-extras');
          if (useDesktop && !desktopExtras) {
            desktopExtras = document.createElement('div');
            desktopExtras.className = 'kaiko-desktop-extras';
            media.append(desktopExtras);
          }
          if (useDesktop) {
            if (slot.parentElement !== desktopExtras) desktopExtras.append(slot);
          } else {
            const wishlist = info.querySelector('#swym-atw-button-container')?.closest('.product__block');
            const anchor = wishlist || buy;
            if (slot.previousElementSibling !== anchor) anchor.after(slot);
          }
          const summaryWidget = this.root.querySelector('[id*="judge_me_reviews_store_summary"]');
          const summaryBlock = summaryWidget?.closest('.product__block');
          if (summaryBlock) {
            if (!this.summaryHome?.isConnected) {
              this.summaryHome = document.createComment('kaiko-summary-position');
              summaryBlock.before(this.summaryHome);
            }
            if (useDesktop) {
              if (summaryBlock.parentElement !== desktopExtras || summaryBlock.previousElementSibling !== slot) {
                slot.after(summaryBlock);
              }
            } else if (summaryBlock.previousSibling !== this.summaryHome) {
              this.summaryHome.after(summaryBlock);
            }
          }
          this.root.querySelectorAll('.cbb-frequently-bought-container').forEach(bundle => {
            if (bundle.parentElement !== slot) slot.append(bundle);
          });
        }
        this.root.querySelectorAll('.product__block--description:not([data-kaiko-folded])').forEach(description => {
          description.dataset.kaikoFolded = 'true';
          const nodes = Array.from(description.childNodes);
          const isHeading = node => node.nodeType === 1 && /^H[2-6]$/.test(node.tagName);
          const headings = nodes.filter(isHeading);
          if (headings.length < 2) return;
          let group = [], heading = null;
          const groups = [];
          nodes.forEach(node => {
            if (isHeading(node)) {
              if (group.length) groups.push({ heading, nodes: group });
              heading = node; group = [node];
            } else group.push(node);
          });
          if (group.length) groups.push({ heading, nodes: group });
          let firstHeading = true;
          groups.forEach(group => {
            if (!group.heading) return;
            if (firstHeading) { firstHeading = false; return; }
            if (/safety|warning|caution|age|important/i.test(group.heading.textContent)) return;
            const details = document.createElement('details');
            details.className = 'kaiko-description-details';
            const summary = document.createElement('summary');
            const content = document.createElement('div');
            content.className = 'kaiko-description-content';
            group.heading.before(details);
            summary.append(group.heading);
            group.nodes.slice(1).forEach(node => content.append(node));
            details.append(summary, content);
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
